<div class="container-fluid" *ngIf="neutInputModels.length > 0">
  <div class="row align-items-start justify-content-center" *ngIf="!isCurrentDoorSliding && !isNeutenSectionInvalid && !showDealerContactMessage">
    <div class="col bg-white py-4 mx-2 my-2 rounded-4 restricted-size-panel">
      <app-daagmaat
        #daagmaatA
        [input]="neutInputModels[0]"
        [count]="count"
        [dorpelCode]="currentDorpelCode"
        [dorpelType]="currentDorpelType"
        [index]="0"
        isDaagmaatA="true"
      ></app-daagmaat>
    </div>
    
    <ng-container *ngFor="let neut of neutInputModels; let i = index">
      <div class="col bg-white py-4 mx-2 my-2 rounded-4 restricted-size-panel">
        <luv-neut
          #neut
          [input]="neut"
          [count]="count"
          [dorpelCode]="currentDorpelCode"
          [index]="i"
          (voorsponningChanged)="onNeutVoorsponningChanged($event)"
          (currentNeutChanged)="onNeutCodeChanged($event, i)"
        ></luv-neut>
      </div>
      <div class="col bg-white py-4 mx-2 my-2 rounded-4 restricted-size-panel">
        <app-daagmaat
          #daagmaat
          [input]="neut"
          [count]="count"
          [neutDescription]="neut.model.omschrijving"
          [dorpelCode]="currentDorpelCode"
          [dorpelType]="currentDorpelType"
          [index]="i"
        ></app-daagmaat>
      </div>
    </ng-container>
  </div>

  <div class="row align-items-start" *ngIf="showDealerContactMessage">
    <div class="illogical-combination-message">
      <span>De samenstelling van deze dorpel is niet geschikt om te tekenen. Upload de tekening als bijlage in het vorige scherm of neem direct contact op met ons op +31 (0)317 - 612878</span>
    </div>
  </div>

  <div class="row align-items-start justify-content-center" *ngIf="isCurrentDoorSliding">
    <ng-container *ngFor="let neut of neutInputModels; let i = index">
      <div class="col bg-white py-4 mx-2 my-2 rounded-4 restricted-size-panel">
        <luv-neut
          #neut
          [input]="neut"
          [count]="count"
          [dorpelCode]="currentDorpelCode"
          [schema]="currentSchema"
          [index]="i"
          (currentNeutChanged)="onNeutCodeChanged($event, i)"
        ></luv-neut>
      </div>
    </ng-container>
  </div>
  <div [formGroup]="formGroup" class="row align-items-start justify-content-center" *ngIf="canShowRailOptions">
    <div class="col bg-white py-4 mx-2 my-2 rounded-4 col-xl-2 justify-content-center restricted-size-panel">
      <label class="form-label"><b>Rail:</b></label>
      <select
        class="form-select"
        id="railType"
        formControlName="railType"
        (change)="onRailTypeChange()"
      >
        <option value="" disabled selected hidden>Kies</option>
        <option value="Hoge rail">Hoge rail</option>
        <option value="Lage rail">Lage rail</option>
      </select>
    </div>
  </div>
</div>
